<div data-scroll-container>
  <div class="content relative h-screen">
    <div class="progress-bar" [style.height.%]="scrollProgress"></div>
    <div class="home block lg:flex items-center" id="about_page"><app-contact></app-contact></div>
  </div>
</div>
